import { render, staticRenderFns } from "./AppInvoice.vue?vue&type=template&id=f8d3c412&scoped=true"
import script from "./AppInvoice.vue?vue&type=script&lang=js"
export * from "./AppInvoice.vue?vue&type=script&lang=js"
import style0 from "./AppInvoice.vue?vue&type=style&index=0&id=f8d3c412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d3c412",
  null
  
)

export default component.exports